document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 800,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.sw-but-img-next',
            prevEl: '.sw-but-img-prev'
        },
        pagination: {
            clickable: true,
            el: ".swiper-pagination",
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    // start slider default
    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });

    let slider = new Swiper(".slider-columns", {
        loop: true,
        slidesPerView: 1, 
        spaceBetween: 0, 
        centeredSlides: true,
        navigation: {
            nextEl: ".sw-but-img-next",
            prevEl: ".sw-but-img-prev",
        },
        breakpoints: {
            640: { 
                slidesPerView: 1.5,
                spaceBetween: 90,
            },
            1024: { 
                slidesPerView: 2.1,
                spaceBetween: 115,
            }
        }
    });

    let cards = new Swiper(".card-swiper", {
        speed: 700,
        loop:true,
        effect: "fade",
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".sw-gal-next",
            prevEl: ".sw-gal-prev",
        }
    });

    // Itinerary Swiper ****************************************************************

    let itineraryBlock = document.querySelectorAll('.slider-itinerary');
    let itinerarySlide = document.querySelectorAll('.slider-itinerary-swiper');

    if (itinerarySlide) {
        const locationSlider = new Swiper('.slider-itinerary-swiper', {
            loop: true,
            effect: "fade",
            speed:700,
            autoplay: {
                delay: 3500,
                disableOnInteraction: false,
            },
            fadeEffect: {
                crossFade: true
            },
            pagination: {
                clickable: true,
                el: ".swiper-pagination",
            },
            navigation: {
                nextEl: ".sw-but-img-next",
                prevEl: ".sw-but-img-prev",
            }
        });

        //activate atoplay swipper only visible
        const sliderElement = document.querySelector('.slider-itinerary-swiper');
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    locationSlider.autoplay.start();
                } else {
                    locationSlider.autoplay.stop();
                }
            });
        }, {
            threshold: 0.5
        });

        if(sliderElement){
            observer.observe(sliderElement);
        }

        itineraryBlock.forEach(function() {
            let tags = document.querySelectorAll('.js-tag');
            let slidesToShow = document.querySelectorAll('.js-item-tag');
            let hourItems = document.querySelectorAll('.js-hour span');

            // Function to update visible slides
            const updateVisibleSlides = (primaryDataTag) => {
            // Clear all current slides
            locationSlider.removeAllSlides();

            // Add only the visible slides
            slidesToShow.forEach(item => {
                let secondaryDataTag = item.dataset.tag;
                if (primaryDataTag === secondaryDataTag) {
                    // Add the slide to Swiper
                    locationSlider.appendSlide(item);  
                } 
            });

            // Force Swiper to update pagination
            locationSlider.update();
            locationSlider.slideTo(0); 

            // Update visibility of hourItems
            hourItems.forEach(hourItem => {
                let hourDataTag = hourItem.dataset.tag;
                (primaryDataTag === hourDataTag) ? hourItem.classList.remove('hidden') : hourItem.classList.add('hidden');  
            });
        };
        if (window.screen.width > 640) {
        // Show the default first tag and its corresponding slides
            let firstTag = tags[0];
            firstTag.classList.add('active');
            updateVisibleSlides(firstTag.dataset.tag);

            tags.forEach(function(tag) {
                tag.addEventListener('click', function(e) {
                    e.preventDefault();
                    tags.forEach(function(tag) {
                        tag.classList.remove('active');
                    });
                    this.classList.add('active');
                    updateVisibleSlides(tag.dataset.tag);
                });
            });
            
        } else{
            let selectTag = document.querySelector('#tagSelect');
            updateVisibleSlides(selectTag.value);  
                selectTag.addEventListener('change', function(e) {
                    let selectedValue = e.target.value;
                    updateVisibleSlides(selectedValue);
                });
            }
        });
    }
    

    let gallerySlider = document.querySelectorAll('.gallery-slider');
    if(gallerySlider){
        gallerySlider.forEach((item)=> {
            new Swiper('.gallery-slider', {
                loop: true,
                speed: 700,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                navigation: {
                    nextEl: ".sw-but-img-prev",
                    prevEl: ".sw-but-img-next",
                }
            });
        });
    }


});